import { logger } from '@/shared/utils';
import { Loader } from '@/components';
import PropTypes from 'prop-types';
import React from 'react';
import { useProfileImage } from '../viewmodels/useProfileImage';

const ProfileImage = React.memo(
   ({ imageUri, userId, alt = 'Image', defaultImg, className = '', setImageSource, style, ...rest }) => {
      const { src, loading } = useProfileImage({ imageUri, userId, defaultImg, setImageSource });
      const [renderError, setRenderError] = React.useState(false);

      if (loading) {
         return (
            <div className={`${className} ct-flexCenter`}>
               <Loader />
            </div>
         );
      }

      if (src && !renderError && typeof src === 'string') {
         return (
            <img
               src={src}
               alt={alt}
               className={className}
               loading="lazy"
               referrerPolicy="no-referrer"
               onError={e => {
                  logger.debug('Profile image render error', e);
                  setRenderError(true);
               }}
               style={{ backgroundColor: 'transparent' }}
               {...rest}
            />
         );
      }

      return (
         <div className={className} style={style}>
            {defaultImg}
         </div>
      );
   },
   (prev, next) =>
      prev.imageUri === next.imageUri &&
      prev.userId === next.userId &&
      prev.className === next.className &&
      prev.defaultImg === next.defaultImg,
);

ProfileImage.displayName = 'ProfileImage';

ProfileImage.propTypes = {
   imageUri: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Blob)]),
   userId: PropTypes.string,
   alt: PropTypes.string,
   defaultImg: PropTypes.string,
   className: PropTypes.string,
   setImageSource: PropTypes.func,
   style: PropTypes.object,
};

export default ProfileImage;
